// extracted by mini-css-extract-plugin
module.exports = {"listiclePageWrapper":"poaHe"};